export enum Afix {
  prefix = "prefix",
  suffix = "suffix",
}
